import React, { useState, useEffect } from "react";
import {
  Input,
  Chip,
  Modal,
  ModalContent,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Button,
  Tooltip,
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@nextui-org/react";
import { quoteChipColor, requestStyle, chipValue } from "../../data/styleData";
import { IoInformationCircle } from "react-icons/io5";
import { useFieldArray, Controller, useForm } from "react-hook-form";
import Capricorn_logo from "../../assets/images/Capricorn_logo.png";
import { getQuoteById } from "../../store/slices/customerSlice";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ImageSlider from "../../components/ImageSlider";
import ChatBox from "../../components/ChatBox";
import { toast } from "react-toastify";
import logo from "../../assets/images/Capricorn_logo.png";
import axios from "axios";
import AcceptModal from "./AcceptModal";
import { warranty } from "../../store/slices/adminSlice";
import { ImPrevious } from "react-icons/im";

const UpdateStatus = () => {
  const { supplier_id, singleRequest, quote_images } = useSelector(
    (state) => state.customer
  );
  const {
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      parts_name: [{ part_id: 0, quantity: 0 }],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "parts_name",
  });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [supplier, setSupplier] = useState([]);
  const [approval, setApproval] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [quote, setQuote] = useState({});
  const { id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [approvedQuotes, setApprovedQuotes] = useState(new Set());
  const [actionType, setActionType] = useState("");
  const [WarrantyStatus, setWarrantyStatus] = useState({});
  const [toggleChecked, settoggleChecked] = useState({});
  const isAnyWarrantyActive = Object.values(toggleChecked).includes(true);
  // Object.values(toggleChecked).some(value => value === true);

  const getSupplierInfo = async (id) => {
    try {
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/users/profile/${id}`
      );
      let data = res.data?.details?.user;
      setSupplier(data);
    } catch (error) {
      let err = error.response?.data.message;
      toast.error(err);
    }
  };
  // console.log("settoggleChecked", toggleChecked);

  const handleCheckedToggles = (response) => {
    const result = {};

    response.details.quote.QuoteOptions.forEach((option) => {
      result[option.id] = option.has_warranty;
    });
    // console.log("result", result);
    result[response.details.quote.id] = response.details.quote.has_warranty;
    // console.log("responnnnssseeeeeee", result);
    settoggleChecked(result);
  };
  const getQuote = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/quotes/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setQuote(res.data.details?.quote);
      // console.log("result-asdjfnasjdkf", res);
      handleCheckedToggles(res?.data);
    } catch (error) {
      let err = error.response?.data?.message;
      toast.error(err);
    }
  };

  const getApprovalOffer = async (option) => {
    try {
      const token = localStorage.getItem("accessToken");
      let res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/quotes/approve/${id}`,
        {
          option_approvals: [
            {
              option_id: option?.id,
              approval: !option?.approval,
            },
          ],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      getQuote();
    } catch (error) {
      let err = error.response.data.message;
      toast.error(err);
    }
  };

  const handleApprove = () => {
    updateStatus("Accepted");
  };

  const handleReject = () => {
    updateStatus("Rejected");
    onClose();
  };

  const handleToggleWarranty = (Id, checked) => {
    setWarrantyStatus((prev) => {
      const newState = { ...prev, [Id]: checked };
      return newState;
    });
    settoggleChecked((prev) => {
      const state = { ...prev, [Id]: checked };
      return state;
    });
  };
  const openModal = (type, option = null) => {
    setActionType(type);
    setSelectedOption(option);
    setIsModalOpen(true);
  };
  const handleConfirm = () => {
    if (actionType === "handleApprove") {
      handleApprove();
    } else if (actionType === "getApprovalOffer" && selectedOption) {
      getApprovalOffer(selectedOption);
    }
    setIsModalOpen(false);
  };
  const updateStatus = async (status) => {
    try {
      const token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      let data = {
        status: status,
      };
      let res = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/requests/quote/update/status/${id}`,
        data,
        header
      );
      toast.success(res?.data?.message);
      if (status === "Accepted") {
        setApproval("accept");
        setTimeout(() => {
          navigate(`/accept-quote/${id}`);
        }, 1500);
      } else if (status === "Rejected") {
        setApproval("reject");
      }
    } catch (error) {
      let err = error.response?.data?.message;
      toast.error(err);
    }
  };

  const handleNavigate = () => {
    setTimeout(() => {
      navigate(`/accept-quote/${id}`);
    }, 500);
  };

  const totalPriceWithTax = (value) => {
    let total_val = (value * (10 / 100)).toFixed(2);
    return Number(total_val) + value;
  };

  useEffect(() => {
    dispatch(getQuoteById(id));
    getQuote();
    if (supplier_id) {
      getSupplierInfo(supplier_id);
    }
  }, [dispatch, id, supplier_id]);

  useEffect(() => {
    if (supplier_id) {
      getSupplierInfo(supplier_id);
    }
  }, [supplier_id, singleRequest, quote_images]);

  return (
    <div>
      <p className="border-b-1 border-gray-200 pb-1 font-semibold mb-7">
        Update Status
      </p>
      <div className="grid gap-1 md:grid-cols-2 w-full h-auto md:h-auto sm:!h-auto border-box ">
        <div className="h-[440px] overflow-hidden w-full ">
          <div className="m-4 mr-10 mb-20 overflow-hidden ">
            {quote_images.length > 0 ? (
              <ImageSlider images={quote_images} width={"80%"} />
            ) : (
              <div className="flex justify-center items-center w-full min-h-[200px]">
                {" "}
                <p>No Images Found</p>
              </div>
            )}
          </div>
        </div>
        <div>
          <p className="font-semibold mb-5">Quote Details</p>
          <div>
            <div className="flex gap-2 items-center justify-between mb-7">
              <div className="flex gap-3 items-center ">
                {supplier?.profile_id && (
                  <img
                    src={supplier.profile_id}
                    alt="supplier avatar"
                    className="rounded-full"
                    width="50px"
                    height="50px"
                  />
                )}
                {/* {console.log("Image", supplier.profile_id)} */}

                <div>
                  <p className="capitalize text-sm">{supplier?.company_name}</p>
                  {/* {console.log("supplier", supplier)} */}
                  <p className="text-xs font-[300]">SUPPLIER</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {supplier?.capricorn_number && (
                  <img
                    src={Capricorn_logo}
                    alt=""
                    className="w-[28px] h-[28px]"
                  />
                )}
                <Chip
                  color={quoteChipColor[quote.status]}
                  variant="dot"
                  className={requestStyle[quote.status]}
                >
                  {chipValue[quote.status]}
                </Chip>
              </div>
            </div>
            <div className="space-y-4">
              <div className="grid grid-cols-3 gap-4 justify-around ">
                <div className="capitalize flex flex-col w-full">
                  <p className="font-semibold">Email</p>
                  <p className="mt-1 break-words">{supplier?.email}</p>
                </div>
                <div>
                  <p className="font-semibold">Phone Number</p>
                  <p>{supplier?.phone}</p>
                </div>
                <div>
                  <p className="font-semibold">Company Name</p>
                  <p>{supplier?.company_name}</p>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 justify-around ">
                <div className="capitalize">
                  <p className="font-semibold">Vehicle Make</p>
                  <p>
                    {singleRequest?.VehicleMake?.name
                      ? singleRequest?.VehicleMake?.name.toLowerCase()
                      : singleRequest?.custom_make}
                  </p>
                </div>
                <div className="capitalize">
                  <p className="font-semibold">Vehicle Model</p>
                  <p>
                    {singleRequest?.VehicleModel?.name
                      ? singleRequest?.VehicleModel?.name.toLowerCase()
                      : singleRequest?.custom_model}
                  </p>
                </div>
                <div className="capitalize">
                  <p className="font-semibold capitalize">Part</p>
                  <p>
                    {singleRequest?.Part
                      ? singleRequest?.Part?.name.toLowerCase()
                      : singleRequest?.custom_part_type}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 justify-around ">
                <div className="capitalize">
                  <p className="font-semibold">Rego</p>
                  <p>{singleRequest?.rego}</p>
                </div>
                <div>
                  <p className="font-semibold">Quantity</p>
                  <p>{singleRequest?.quantity}</p>
                </div>
                <div className="capitalize">
                  <p className="font-semibold">Fuel Type</p>
                  <p>{singleRequest?.fuelType?.name || "Not Provided"}</p>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 justify-around ">
                <div>
                  <p className="font-semibold">Transmission</p>
                  <p>
                    {singleRequest?.transmissionModel?.name || "Not Provided"}
                  </p>
                </div>
                <div className="capitalize">
                  <p className="font-semibold ">Body Style</p>
                  <p>{singleRequest?.bodyStyle?.name || "Not Provided"}</p>
                </div>
              </div>

              <div className="block sm:flex  gap-[90px] ">
                <div className="sm:grid sm:grid-row-2 ">
                  <label className="block  font-semibold">Shipping Date</label>
                  <p className="text-base">
                    {quote?.shipping_date
                      ? new Date(quote.shipping_date)
                          .toISOString()
                          .split("T")[0]
                          .split("-")
                          .reverse()
                          .join("-")
                      : ""}
                  </p>
                </div>

                <div className="sm:grid sm:grid-row-2">
                  <label className="block  font-semibold">
                    Sales Representative
                  </label>
                  <p className="text-base">
                    {quote?.SupplierSalesRep?.SalesRepName}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-full justify-end h-[40px]">
            {quote.status === 1 || quote.status === 2 ? (
              <div
                className={`grid  ${
                  approval ? "" : "grid-cols1"
                } gap-3 mb-5 mt-5`}
              >
                {approval === "accept" ? (
                  ""
                ) : (
                  <Button
                    className="bg-purpleBtn text-white font-semibold"
                    onPress={approval === "reject" ? "" : () => onOpen()}
                  >
                    {approval === "reject" ? "Rejected" : "Reject"}
                  </Button>
                )}
              </div>
            ) : quote?.status === 3 || quote?.status === 8 ? (
              <Button
                className="bg-lightBlue mt-4 mb-32 float-right text-white font-semibold mobile-only:w-full mobile-only:mt-3"
                onClick={handleNavigate}
              >
                {" "}
                Check Status
              </Button>
            ) : quote?.status === 4 ? (
              <Button className="bg-purpleBtn text-white font-semibold mobile-only:w-full mobile-only:mt-3">
                {" "}
                Rejected
              </Button>
            ) : (
              " "
            )}
          </div>
        </div>
      </div>

      {quote?.QuoteStatus?.status === "Awaiting approval" && (
        <div>
          <h1 className="font-semibold text-lg mb-5">Quoted Parts</h1>
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse">
              <thead className=" text-white">
                <tr>
                  <th className="border-2 border-black w-24 py-6 bg-black">
                    Part Type
                  </th>
                  {/* <th className="border-2 border-black p-2 px-3 md:px-1 bg-black">Quantity</th> */}
                  <th className="border-2 border-black w-24 bg-black">
                    Quantity
                  </th>
                  {/* <th className="border-2 border-black p-2 px-4 md:px-3 bg-black">Price</th> */}
                  <th className="border-2 border-black w-36 bg-black">Price</th>
                  <th className="border-2 border-black w-36 md:px-1 bg-black">
                    Freight Price
                  </th>
                  <th className="border-2 border-black w-44 bg-black">
                    Standard Warranty Duration
                  </th>
                  <th className="border-2 border-black w-44 bg-black">
                    Optional Extended Warranty Offer
                  </th>
                  <th className="border-2 border-black w-36 bg-black">
                    Despatch date
                  </th>
                  <th className="border-2 border-black w-36 bg-black">
                    Total Price
                  </th>
                  <th className="p-2 w-[100px] md:min-w-[0px] md:px-1"></th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-white relative min-h-[90px]">
                  <td className="border-2 border-black p-2 py-2 text-center">
                    <div className="flex justify-center items-center gap-2 w-full">
                      <p className="capitalize">
                        {singleRequest?.Part?.name
                          ? singleRequest?.Part?.name.toLowerCase()
                          : singleRequest?.custom_part_type?.toLowerCase()}
                      </p>

                      <Tooltip
                        className="w-56 h-52 p-4 text-center overflow-y-auto whitespace-normal justify-center"
                        content={
                          <div className="px-1 py-2">
                            <div className="text-small font-semibold mt-5">
                              Notes
                            </div>
                            <div className="text-tiny">{quote.notes}</div>
                          </div>
                        }
                        size="md"
                        isDisabled={!quote?.notes || quote?.notes === ""}
                      >
                        <div className="flex items-center justify-center">
                          <IoInformationCircle size={20} />
                        </div>
                      </Tooltip>
                    </div>
                  </td>

                  <td className="border-2 border-black p-2 text-center">
                    {singleRequest?.quantity}
                  </td>
                  <td className="border-2 border-black p-2 text-center">
                    ${quote.part_price}
                  </td>
                  <td className="border-2 border-black p-2 text-center">
                    ${quote?.freight_price}
                  </td>
                  <td className="border-2 border-black p-2 text-center capitalize">
                    {quote?.warrantyDuration?.duration}{" "}
                    {quote?.warrantyDuration?.unit?.toLowerCase()}
                  </td>

                  <td className="border-2 border-black p-2 text-center capitalize">
                    {quote?.warranty_option?.trim() || quote?.warranty_price
                      ? `${
                          quote?.warranty_option?.trim()
                            ? quote.warranty_option.toLowerCase()
                            : ""
                        }${
                          quote?.warranty_option?.trim() &&
                          quote?.warranty_price
                            ? " - "
                            : ""
                        }${
                          quote?.warranty_price
                            ? `$${quote.warranty_price}`
                            : ""
                        }`
                      : "Not Provided"}
                  </td>

                  <td className="border-2 border-black p-2 text-center capitalize">
                    {quote?.shipping_date
                      ? new Date(quote.shipping_date).toLocaleDateString(
                          "en-GB"
                        )
                      : "Not Provide"}
                  </td>

                  <td className="border-2 border-black p-2 text-center">
                    ${quote?.total_price}
                  </td>

                  <td className="text-center relative">
                    <div className="inline-block bg-white rounded">
                      <button
                        className="bg-lightBlue text-white px-4 h-[40px] text-sm whitespace-nowrap rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={
                          approval === "accept"
                            ? null
                            : () => openModal("handleApprove")
                        }
                        disabled={
                          isAnyWarrantyActive && !toggleChecked[quote.id]
                        }
                      >
                        {approvedQuotes.has(quote?.Request?.id)
                          ? "Check Status"
                          : "Accept Quote"}
                      </button>
                    </div>
                  </td>
                </tr>
                {/* {console.log("quotes--->", quote)} */}
                {/* {console.log("qutes options--->", quote.QuoteOptions)} */}
                {/* {console.log("warranty status --->", WarrantyStatus)} */}
                {quote?.QuoteOptions?.length > 0 &&
                  quote?.QuoteOptions?.map((option, index) => (
                    <tr key={index} className="bg-white relative">
                      <td className="border-b-2 border-l-2 border-black p-2 py-5 text-center flex items-center justify-center capitalize">
                        <p>
                          {option.Part?.name
                            ? option.Part?.name.toLowerCase()
                            : option?.custom_part_type.toLowerCase()}
                        </p>
                        <Tooltip
                          className="w-56 h-52 p-4 text-center overflow-y-auto whitespace-normal"
                          content={
                            <div className="px-1 py-2">
                              <div className="text-small font-semibold mt-5">
                                Notes
                              </div>
                              <div className="text-tiny">{option.notes}</div>
                            </div>
                          }
                          size="md"
                          isDisabled={!option?.notes || option?.notes === ""}
                        >
                          <div>
                            <IoInformationCircle size={20} />
                          </div>
                        </Tooltip>
                      </td>
                      <td className="border-2 border-black p-2 text-center">
                        {option.quantity}
                      </td>
                      <td className="border-2 border-black p-2 text-center">
                        ${option.part_price}
                      </td>
                      <td className="border-2 border-black p-2 text-center">
                        ${option?.freight_price}
                      </td>
                      <td className="border-2 border-black p-2 text-center capitalize">
                        {option?.warrantyDuration?.duration}{" "}
                        {option?.warrantyDuration?.unit}
                      </td>
                      <td className="border-2 border-black p-2 text-center capitalize">
                        {option?.warranty_option && option?.warranty_price
                          ? `${option?.warranty_option.toLowerCase()} - $${
                              option?.warranty_price
                            }`
                          : "Not Provided"}
                      </td>
                      <td className="border-2 border-black p-2 text-center capitalize">
                        {quote?.shipping_date
                          ? new Date(quote.shipping_date).toLocaleDateString(
                              "en-GB"
                            )
                          : "Not Provide"}
                      </td>
                      <td className="border-2 border-black p-2 text-center">
                        ${option?.total?.toFixed(2)}
                      </td>

                      <td className="text-center w-[100px]">
                        <div className="inline-flex  items-center justify-center  bg-white rounded">
                          <button
                            className="bg-lightBlue text-white px-4 h-[40px] text-sm whitespace-nowrap rounded disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={() =>
                              openModal("getApprovalOffer", option)
                            }
                            disabled={
                              isAnyWarrantyActive && !toggleChecked[option.id]
                            }
                          >
                            {approvedQuotes.has(option?.id)
                              ? "Check Status"
                              : "Accept Quote"}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div className="mt-5">
        <ChatBox quoteId={id} />
      </div>
      <Modal size={"xs"} isOpen={isOpen} onClose={onClose} className="p-3">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalBody>
                <p className="text-base font-semibold text-center">
                  Are you sure?
                </p>
              </ModalBody>
              <ModalFooter className="grid grid-cols-2 justify-between p-4 mt-4">
              <Button
                  className="border-2 bg-transparent hover:bg-green-400 hover:text-white font-semibold border-green-400 text-green-400"
                  onClick={handleReject}
                >
                  Yes
                </Button>
                <Button
                  className="border-2 hover:borderfont-semibold bg-transparent hover:bg-orange-400 hover:text-white border-orange-400 text-orange-400"
                  onPress={onClose}
                >
                  No
                </Button>
             
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
      <AcceptModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        quoteId={selectedOption?.quote_id || quote.id}
        Id={selectedOption?.id || quote.id}
        accessToken={localStorage.getItem("accessToken")}
        isWarranty={WarrantyStatus[selectedOption?.id || id] || false}
        onToggleWarranty={handleToggleWarranty}
        initialTotalPrice={quote.total_price}
        initialWarrantyPrice={quote.warranty_price}
        initialOptionTotalPrice={selectedOption?.total || null}
        initialOptionWarrantyPrice={selectedOption?.warranty_price || null}
        // initialHasWarranty={toggleChecked[selectedOption?.id] || quote.id ?? false}
        // initialHasWarranty={
        //   toggleChecked[selectedOption?.id] || toggleChecked[quote?.id] || false
        // }
        initialHasWarranty={
          toggleChecked[selectedOption?.id || quote?.id] || false
        }
        dispatchDate={
          quote?.shipping_date
            ? new Date(quote.shipping_date)
                .toISOString()
                .split("T")[0]
                .split("-")
                .reverse()
                .join("-")
            : ""
        }
      />
    </div>
  );
};
export default UpdateStatus;
